module.exports = __webpack_public_path__ + "img/car-crash.ec4d7bc0.svg";